module.exports = __webpack_public_path__ + "media/images/List2-1c027dfd05a8692692edadd012820c06.svg";